export default "__VITE_ASSET__BcoiDAOb__"